import React, { useContext, useMemo } from "react";

type ContextType = {
  expandedTitle: string | null;
  setExpandedTitle: React.Dispatch<string | null>;
};

const Context = React.createContext<ContextType>(null!);

type HookReturnType = {
  isExpanded: boolean;
  expand: React.DispatchWithoutAction;
  collapse: React.DispatchWithoutAction;
};

export const SubmenuExpandCollapseProvider: React.FC = ({ children }) => {
  const [expandedTitle, setExpandedTitle] = React.useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      expandedTitle,
      setExpandedTitle,
    }),
    [expandedTitle]
  );

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export function useSubmenuExpand(title: string): HookReturnType {
  const context = useContext(Context);
  return {
    isExpanded: title === context.expandedTitle,
    expand: () => context.setExpandedTitle(title),
    collapse: () => context.setExpandedTitle(null),
  };
}
